export const SET_ABSCHLUSS = "setAbschluss";
export const SET_ANZEIGEMODUS = "setAnzeigemodus";
